import { Component } from 'react';
import { store } from 'store';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { get, put } from 'helpers/apiHelpers';
import { ROLE_SHOW_BRAND, ROLE_EDIT_SHOW_MENU_PAGE } from 'helpers/roles';
import withStyles from '@material-ui/core/styles/withStyles';
import extendedFormsStyle from 'assets/jss/material-dashboard-pro-react/views/extendedFormsStyle';
import { withTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

const DietDelivery = WrappedComponent =>
  // eslint-disable-next-line react/display-name -- FIXME
  class extends Component {
    state = {
      resources: {},
      pageDescription: '',
      modules: {},
    };

    async componentDidMount() {
      const { selectedBrand } = this.props;
      const [modules] = await Promise.all([
        get(
          `brands/${selectedBrand}/modules?module[]=MenuPage&module[]=ConfigClientPanel&module[]=SeoCmsMenuSubpage`
        ),
      ]);

      const { '@resources': resources, ...menuPageConfigs } =
        modules.configuration.MenuPage;

      this.setState({
        resources,
        modules,
        ...menuPageConfigs,
      });
    }

    handleInputChange = event => {
      this.setState({ [event.target.name]: event.target.value });
    };

    handleToggle = event => {
      this.setState({
        [event.target.name]: !this.state[event.target.name],
      });
    };

    getImage = (stateName, data) => {
      this.setState(prevState => ({
        resources: {
          ...prevState.resources,
          [data['@id']]: data,
        },
        [stateName]: data?.['@id'] || null,
      }));
    };

    removeImage = stateName => {
      this.setState({
        [stateName]: null,
      });
    };

    setModules = setState => {
      this.setState(prevState => ({
        modules: setState(prevState.modules),
      }));
    };

    handleSubmit = () => {
      const { selectedBrand, t } = this.props;

      const {
        bannerMobile,
        bannerDesktop,
        bannerInfoEnabled,
        bannerTitle,
        pageDescription,
        bannerDescription,
        menuButtonLink,
        showMenuButton,
      } = this.state;

      put(`brands/${selectedBrand}/modules`, {
        configuration: {
          MenuPage: {
            menuButtonLink,
            showMenuButton,
            pageDescription,
            bannerTitle,
            bannerInfoEnabled,
            bannerDescription,
            bannerMobile,
            bannerDesktop,
          },
          ConfigClientPanel: this.state.modules.configuration.ConfigClientPanel,
          SeoCmsMenuSubpage: this.state.modules.configuration.SeoCmsMenuSubpage,
        },
        // eslint-disable-next-line promise/prefer-await-to-then -- FIXME
      }).then(() => {
        toast.success(t('status.success.save'));
      });
    };

    render() {
      const { roles } = store.getState().Auth.user;
      const allowedToModify = roles.includes(ROLE_EDIT_SHOW_MENU_PAGE);
      const allowToModifyFiltering = roles.includes(ROLE_SHOW_BRAND);

      return (
        <WrappedComponent
          {...this.state}
          saveAll={this.saveAll}
          classes={this.props.classes}
          getImage={this.getImage}
          removeImage={this.removeImage}
          handleToggle={this.handleToggle}
          handleSubmit={this.handleSubmit}
          allowedToModify={allowedToModify}
          handleInputChange={this.handleInputChange}
          allowToModifyFiltering={allowToModifyFiltering}
          bannerMobile={this.state.resources[this.state.bannerMobile]}
          bannerDesktop={this.state.resources[this.state.bannerDesktop]}
          modules={this.state.modules}
          setModules={this.setModules}
        />
      );
    }
  };

export default compose(
  withTranslation(),
  withStyles(extendedFormsStyle),
  connect(({ Auth: { selectedBrand }, Diets: { diets } }) => ({
    selectedBrand,
    diets,
  })),
  DietDelivery
);
